import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisActiveDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

// The campaign's own first/last review date, for the top-bar picker's
// "Lifetime" preset on review-analysis routes. Mirrors
// useGetInboxActiveDateRangeQuery — the account-wide range the picker defaults
// to covers social-listening mentions, which can start long after a campaign's
// reviews do (BOG: mentions from 2026-07-27, reviews from 2026-04-30), making
// Lifetime hide almost every review.
export const useGetReviewAnalysisActiveDateRangeQuery = (
  campaignId?: string
) => {
  return useQuery({
    enabled: !!campaignId,
    queryFn: (): Promise<ReviewAnalysisActiveDateRange> =>
      ReviewAnalysisApiService.getActiveDateRange(campaignId as string),
    queryKey: [QueryKey.GET_REVIEW_ANALYSIS_ACTIVE_DATE_RANGE, campaignId],
  })
}
